import React from "react";
import { connect } from "react-redux";
import {
  deleteReception,
  fetchReception,
} from "../../utils/queries/reception/receptionQuery.js";
import { ROLE_RECEPTION } from "../../constants/ROLES.js";
import Table from "../Table/Table.js";
import { getStorage } from "../../utils/storage.js";
import language from "../../language";
import { defineRole } from "../../utils/handleAccessRoles.js";
import icons from "../../constants/icons.js";
import ShippingQueue from "../Requests/shipping/ShippingQueue.js";
import ModalContainer from "../Modal/Modal.js";
import { DeleteModal } from "../Modal/index.js";
import toastMessage from "../../utils/toastMessage.js";

class Reception extends React.Component {
  state = {
    isLoading: false,
    data: [],
    page: 1,
    limit: 10,
    search_text: "",
    selectedData: {},
    delete_value: "",
    error: {},
    csvData: [],
    user: {},
  };

  componentDidMount = async () => {
    const user = await getStorage();
    this.setState({ user });

    // A shipmentNumber from a booking prompt names the shipment the ward was
    // sent here to receive, so prefill the search instead of making them find
    // it in the list. handleRemoteSearch already filters on this field.
    const shipmentNumber = new URLSearchParams(window.location.search).get(
      "shipmentNumber"
    );

    if (shipmentNumber) {
      await new Promise((r) =>
        this.setState({ search_text: shipmentNumber }, r)
      );

      await this.handleRemoteSearch(shipmentNumber);

      return;
    }

    await this.getData(true);
  };

  onChangeText(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({
      [field]: e?.target?.value,
      error,
    });
  }

  getData = async (isLoading, search = {}) => {
    try {
      const { page, limit } = this.state;
      const { defaultLanguage } = this.props;

      this.setState({ isLoading });

      const { data, count, totalRecords } = await fetchReception(defaultLanguage, {
        page,
        limit,
        ...search,
        listType: "grouping",
      });

      this.setState({
        data: data,
        totalPageCount: count,
        totalRecords,
        isLoading: false,
      });
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  handlePagination(page, _tab, limit) {
    this.setState(
      {
        page,
        ...(limit != null && { limit }),
      },
      () => {
        this.getData(true);
      }
    );
  }

  handleShowModal(modal, modalTitle, selectedData) {
    this.setState({
      [modal]: true,
      modalTitle,
      selectedData,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  handleSearch = async (e) => {
    const search = e?.target?.value;
    this.setState({ search_text: search });
  };

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].shipment_number,
        key: "shipmentNumber",
        styles: {
          textTransform: "lowercase",
        },
        type: "link",
        onPress: (item) =>
          this.handleOpenModal(
            "showShipmentInformationModal",
            item.shipmentNumber,
            item
          ),
      },
      {
        title: language[this.props.defaultLanguage].product,
        key: "inventory.code",
        styles: {
          textTransform: "lowercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].donation,
        key: "donation.donationNumber",
      },
      {
        title: language[this.props.defaultLanguage].blood_group,
        key: "inventory.bloodGroup",
      },
      {
        title: language[this.props.defaultLanguage].source_stock,
        key: "inventory.sourceStock.name",
      },
      {
        title: language[this.props.defaultLanguage].current_stock,
        key: "inventory.stock.name",
      },
      {
        title: language[this.props.defaultLanguage].category,
        key: "category",
        type: "status",
      },

      // {
      //   title: language[this.props.defaultLanguage].received_by,
      //   key: "addedByDetails.pin",
      //   styles: {
      //     textTransform: "uppercase",
      //   },
      // },
      {
        title: language[this.props.defaultLanguage].status,
        key: "status",
        type: "status",
      },
      // {
      //   title: language[this.props.defaultLanguage].total_products,
      //   key: "totalItems",
      // },
      {
        title: language[this.props.defaultLanguage].actions,
        key: "action",
      },
    ];

    return headers;
  }

  handleRemoteSearch = async (search) => {
    await new Promise((r) => this.setState({ searching: true, page: 1 }, r));

    await this.getData(true, {
      shipmentNumber: search || search !== "" ? search : undefined,
    });

    this.setState({
      searching: false,
    });
  };

  handleOpenModal(modal, title, selectedData) {
    this.setState({
      [modal]: true,
      modalTitle: title,
      selectedData,
    });
  }

  onDelete = async () => {
    try {
      this.setState({ isDeleting: true });

      await deleteReception(this.props.defaultLanguage, {
        shipmentNumber: this.state.selectedData.shipmentNumber,
      });

      this.setState({ isDeleting: false });

      this.getData(true);
      this.handleCloseModal("showDeleteModal");
    } catch (error) {
      this.setState({
        isDeleting: false,
      });

      toastMessage("error", error);
    }
  };

  render() {
    return (
      <>
        <Table
          data={this.state.data}
          isSearch
          page={this.state.page}
          limit={this.state.limit}
          search_text={this.state.search_text}
          addSearchButton
          searching={this.state.searching}
          handleSearch={this.handleSearch.bind(this)}
          handlePressSearch={() =>
            this.handleRemoteSearch(this.state.search_text)
          }
          totalPageCount={this.state.totalPageCount}
          totalRecords={this.state.totalRecords}
          isLoading={this.state.isLoading}
          handlePagination={this.handlePagination.bind(this)}
          headers={this.returnTableHeaders()}
          rowPress={(item) =>
            this.handleShowModal("showModal", item.name, item)
          }
          filters={[
            {
              type: "button",
              title: language[this.props.defaultLanguage].refresh,
              button_type: "button",
              icon: icons.refresh,
              onPress: (item) => this.getData(true, this.state.filters),
            },
          ]}
          actions={[
            {
              canAccess: defineRole({
                roles: this.state.user.accessRole,
                menu: ROLE_RECEPTION,
                operation: "read",
              }),
              name: language[this.props.defaultLanguage].view,
              onPress: (item) =>
                this.handleOpenModal(
                  "showShipmentInformationModal",
                  language[this.props.defaultLanguage].view,
                  item
                ),
              icon: icons.eye_on,
            },
            {
              canAccess: true,
              name: language[this.props.defaultLanguage].delete,
              onPress: (item) =>
                this.handleShowModal(
                  "showDeleteModal",
                  language[this.props.defaultLanguage].delete,
                  item
                ),
              icon: icons.delete,
            },
          ]}
        />
        <ModalContainer
          show={this.state.showShipmentInformationModal}
          title={this.state.modalTitle}
          handleClose={() =>
            this.handleCloseModal("showShipmentInformationModal")
          }
          size="lg"
        >
          <div className="card-body">
            <ShippingQueue
              shipmentNumber={this.state.selectedData.shipmentNumber}
              isRefreshing={this.state.isRefreshing}
              status={this.state.selectedData?.status}
              category={this.state.selectedData?.category}
              isReturn={this.state.selectedData.category === "return"}
            />
          </div>
        </ModalContainer>

        <ModalContainer
          show={this.state.showDeleteModal}
          title={this.state.modalTitle}
          handleClose={() => this.handleCloseModal("showDeleteModal")}
        >
          <div className="card-body">
            <DeleteModal
              handleCloseModal={this.handleCloseModal.bind(
                this,
                "showDeleteModal"
              )}
              error={this.state.error.delete_password}
              value={this.state.delete_value}
              onDelete={this.onDelete.bind(this)}
              onChange={(e) => this.onChangeText("delete_value", e)}
              isDeleting={this.state.isDeleting}
              name={this.state.selectedData.name}
              getData={this.getData.bind(this)}
            />
          </div>
        </ModalContainer>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(Reception);
